import { render, staticRenderFns } from "./selectTaskGroup.vue?vue&type=template&id=2d806790&"
import script from "./selectTaskGroup.vue?vue&type=script&lang=js&"
export * from "./selectTaskGroup.vue?vue&type=script&lang=js&"
import style0 from "./selectTaskGroup.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports